module.exports = __webpack_public_path__ + "media/images/arvut-d7f2c04b4ed83359fea7b656cd4ba1b8.webp";